import { AnimatePresence, motion } from 'motion/react';

import { TargetProfileAssignment } from '../GrowthTab';

import type { RosterEmployee } from '@/api/competency-services/profile-assignment/profileAssignmentService';
import type { EmployeeCompetencyAssignmentFlowProps } from '@/components/CompetencyProfileAssignment';

import { EmployeeCompetencyAssignmentFlow } from '@/components/CompetencyProfileAssignment';

/** The profile the screen assigns: the one the employee holds, or the one they aim for. */
export type AssignmentScreen = 'assign' | 'assignTarget';

interface ProfileAssignmentScreenProps {
    screen: AssignmentScreen;
    employee: RosterEmployee;
    copyCandidates: RosterEmployee[];
    canManageCompetencies: boolean;
    onCreateGuided: EmployeeCompetencyAssignmentFlowProps['onCreateGuided'];
    /** Done or cancelled alike, the profile's tabs come back. */
    onClose: () => void;
}

/** The screen that stands in for the profile's tabs while a competency profile is assigned. */
export const ProfileAssignmentScreen = ({
    screen,
    employee,
    copyCandidates,
    canManageCompetencies,
    onCreateGuided,
    onClose,
}: ProfileAssignmentScreenProps) => (
    <AnimatePresence mode={'wait'}>
        <motion.div
            key={screen}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
            className={'flex flex-col gap-8 p-6'}
        >
            {screen === 'assignTarget' ? (
                <TargetProfileAssignment
                    employee={employee}
                    onDone={onClose}
                    onCancel={onClose}
                />
            ) : (
                <EmployeeCompetencyAssignmentFlow
                    key={employee.assignedProfileId ?? 'unassigned'}
                    employee={employee}
                    copyCandidates={copyCandidates}
                    initialMode={employee.assignedProfileId ? 'selector' : 'choice'}
                    onDone={onClose}
                    onCancel={onClose}
                    onCreateGuided={onCreateGuided}
                    canManageCompetencies={canManageCompetencies}
                />
            )}
        </motion.div>
    </AnimatePresence>
);
